import { render, staticRenderFns } from "./InteractionDoughnutChart.vue?vue&type=template&id=1183a92b&scoped=true&"
import script from "./InteractionDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./InteractionDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./InteractionDoughnutChart.vue?vue&type=style&index=0&id=1183a92b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1183a92b",
  null
  
)

export default component.exports